// extracted by mini-css-extract-plugin
export var thumbnail = "Highlight-module--thumbnail--35R1z";
export var label = "Highlight-module--label--3z1xZ";
export var labelImage = "Highlight-module--labelImage--2p4ld";
export var content = "Highlight-module--content--1OA4Q";
export var text = "Highlight-module--text--1Mx5T";
export var footer = "Highlight-module--footer--2QPOj";